import Vue from "vue";
import Router from "vue-router";
import { ErrorPage } from "@hy/error-page-vue";
import "@hy/error-page-vue/dist/hy-error-page-vue.css";

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      component: () => import("./views/main"),
      redirect: "/home",
      children: [
        {
          path: "/home",
          component: () => import("./views/home"),
          name: "home",
          meta: { title: "搜狐投诉-首页" }
        }
      ]
    },
    {
      path: "/form",
      component: () => import("./views/main"),
      redirect: "/form",
      children: [
        {
          name: "form",
          path: "/form",
          component: () => import("./views/form"),
          meta: { title: "投诉信息填写", requiresAuth: true }
        }
      ]
    },
    {
      path: "/explanation",
      component: () => import("./views/main"),
      redirect: "/explanation",
      children: [
        {
          name: "explanation",
          path: "/explanation",
          component: () => import("./views/explanation"),
          meta: { title: "用户信息搜索", requiresAuth: true }
        }
      ]
    },
    {
      path: "/record",
      component: () => import("./views/main"),
      redirect: "/record",
      children: [
        {
          name: "record",
          path: "/record",
          component: () => import("./views/record/index"),
          meta: { title: "搜狐投诉-投诉信息查看", requiresAuth: true }
        }
      ]
    },
    {
      path: "/detail/:id",
      component: () => import("./views/main"),
      redirect: "/detail/:id",
      children: [
        {
          name: "detail",
          path: "/detail/:id",
          component: () => import("./views/detail/index"),
          meta: { title: "搜狐投诉-投诉信息详情", requiresAuth: true }
        }
      ]
    },
    {
      path: "*",
      redirect: "/404",
      component: ErrorPage,
      props: { errorType: "404" }
    }
  ]
});
